import { getColorPalette, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const base: ThemedFunctor = ({ theme, $color }) => css`
  color: ${getColorPalette(theme, $color)};
  display: flex;
  align-items: center;
  gap: 0.25rem
`;
